import React from "react";
import { useNavigate } from "react-router-dom";
import "./admin.css";
import { useDispatch } from "react-redux";
import adminAction from "../../redux/admin/action";
import employeeAction from "../../redux/employee/action";
import supportAction from "../../redux/support/action";

export function NavbarAdmin({ authType, setAuthType }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setAdmin }         = adminAction;
  const { setEmployee }      = employeeAction;
  const { setSupportMember } = supportAction;

  const logout = () => {
    dispatch(setAdmin({}));
    dispatch(setEmployee({}));
    dispatch(setSupportMember({}));
    setAuthType("");
    localStorage.removeItem("admintoken");
    localStorage.removeItem("emptoken");
    localStorage.removeItem("supporttoken");
    navigate("/");
  };

  return (
    <>
      {/* Topbar */}
      <nav
        className={
          "navbar navbar-expand navbar-light bg-white topbar static-top"
        }
      >
        {/* Sidebar Toggle (Topbar) */}
        {/* <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
                  <i className="fa fa-bars" />
                </button> */}

        {/* Topbar Navbar */}
        <h6 className="ms-4 title">Dashboard</h6>
        <div className=" ms-auto px-3">
          <button className="dashboardBtn" onClick={logout}>
            logout
          </button>
        </div>
      </nav>
      {/* End of Topbar */}
    </>
  );
}
